// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__35seo","formContainer":"styles_formContainer__HQ36m","form":"styles_form__2KiZ0","button":"styles_button__xK_vi","buttons":"styles_buttons__1KZzj"};